document.addEventListener('DOMContentLoaded', () => {
    const shopifyPaymentElement = document.querySelector('shopify-payment-terms');
    const observer = new MutationObserver(() => {
        if (shopifyPaymentElement?.shadowRoot) {
            const icon = shopifyPaymentElement.shadowRoot.querySelector('#shopify-installments-content svg');
            if (icon) {
                icon.style.color = 'rgb(84 51 235)';
                observer.disconnect();
            }
        } else {
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
});